/**
 * How a run ended, as a coloured chip. Used by the list's "last run" column
 * and by the run history.
 */
import { useTranslation } from 'react-i18next';
import Chip from '@mui/material/Chip';
import type { ScheduleRunStatus } from '@forsys/shared';

const COLOUR = {
  running: 'info',
  succeeded: 'success',
  failed: 'error',
  skipped: 'warning',
} as const satisfies Record<ScheduleRunStatus, 'info' | 'success' | 'error' | 'warning'>;

export function RunStatusChip({ status }: { status: ScheduleRunStatus }) {
  const { t } = useTranslation('schedules');
  return <Chip size="small" variant="outlined" color={COLOUR[status]} label={t(`status.${status}`)} />;
}
